export const DEFAULT_SCAN_DURATION = 60;
export const SCAN_DURATION_OPTIONS = [30, 60];
export const SHORT_SCAN_LOCK_MESSAGE = "Available only in a 60-second scan";
export const DEFAULT_FACE_LIVELINESS_DURATION = 50;

export const normalizeScanDuration = (value) => {
  const duration = Number(value);
  return SCAN_DURATION_OPTIONS.includes(duration) ? duration : DEFAULT_SCAN_DURATION;
};

export const getScanDuration = (result, fallback) =>
  normalizeScanDuration(
    fallback ??
      result?.scan_duration ??
      result?.scanDuration ??
      result?.notes?.scan_duration_seconds
  );

export const isMetricValueAvailable = (value) =>
  value !== undefined &&
  value !== null &&
  value !== "" &&
  value !== "--" &&
  !(typeof value === "number" && !Number.isFinite(value));

// CarePlix has not published an exact 30-second metric matrix. Keep direct
// vitals available, but conservatively lock metrics categorized in this app as
// HRV, ANS, or stress-derived. The backend remains the source of all values.
export const isSixtySecondMetric = (metric) =>
  ["SDNN", "RMSSD", "PNN50", "Stress Level", "Mental Wellbeing"].includes(metric);

export const isMetricLocked = (metric, scanDuration) =>
  normalizeScanDuration(scanDuration) < 60 && isSixtySecondMetric(metric);

export const buildScanRouteState = (currentState = {}, overrides = {}) => ({
  ...currentState,
  ...overrides,
  scanDuration: normalizeScanDuration(
    overrides.scanDuration ?? currentState.scanDuration
  ),
});

export const buildFaceScanConfig = (scanDuration, config = {}) => {
  const duration = normalizeScanDuration(scanDuration);
  return {
    ...config,
    strictness: 1,
    scanDuration: duration,
    livelinessDetectionDuration: Math.min(
      DEFAULT_FACE_LIVELINESS_DURATION,
      duration
    ),
  };
};

export const buildFingerScanConfig = (scanDuration, config = {}) => ({
  ...config,
  scanDuration: normalizeScanDuration(scanDuration),
});